import React from 'react';
import TitleUI from 'ui/atoms/Title/Title';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  onClick?: () => void;
}

const Title: React.FC<React.PropsWithChildren<Props>> = ({ onClick }) => (
  <ComponentWrapper onClick={onClick} cursor={onClick !== undefined ? 'pointer' : 'auto'}>
    <TitleUI />
  </ComponentWrapper>
);

export default Title;
